import createContextualizedApp from '@studionand/depi/src/createContextualizedApp';
import '@studionand/depi/src/components/editor/plugins/datepicker/datepicker_styles.scss';

export default createContextualizedApp(() => 'depv');
